* {
  box-sizing: border-box;
  text-decoration: none;
}

a {
  color: #222222;
}

.price-wrapper {
  margin: 0 auto;
  background: transparent url(../../assets/media/grey-bg_960px.svg) no-repeat 0% 0%;
  background-size: 50%;
  border-top: 1px solid #E4E4E4;
  padding-top: 120px;
  padding-bottom: 240px;
  overflow-x: hidden;

  .pages-introduction {
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;

    h2 {
      font-size: 62px;
      line-height: 1.2;
      font-weight: 600;
      max-width: 928px;
      margin: 0 auto;
      margin-bottom: 24px;
    }

    p {
      max-width: 608px;
      margin: 0 auto;
      font-size: 22px;
      line-height: 1.5;
      font-weight: 500;
    }
  }

  .price-page-slider-wrapper {
    max-width: 1052px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 290px;
    padding-left: 20px;
    padding-right: 20px;

    .range {
      position: relative;
      width: 100%;
      height: 8px;

      input {
        width: 100%;
        position: absolute;
        top: 2px;
        height: 0;
        -webkit-appearance: none;
        background-color: #E4E4E4;
      }

      input::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 64px;
        height: 64px;
        margin: -30px 0 0;
        border-radius: 50%;
        background: #F68A33;
        cursor: pointer;
        border: 8px solid #fff !important;
        box-shadow: 0 12px 24px #00000029;
      }

      input::-moz-range-thumb {
        width: 64px;
        height: 64px;
        margin: -30px 0 0;
        border-radius: 50%;
        background: #F68A33;
        cursor: pointer;
        border: 8px solid #fff !important;
        box-shadow: 0 12px 24px #00000029;
      }

      input::-ms-thumb {
        width: 64px;
        height: 64px;
        margin: -30px 0 0;
        border-radius: 50%;
        background: #F68A33;
        cursor: pointer;
        border: 8px solid #fff !important;
        box-shadow: 0 12px 24px #00000029;
      }

      input::-webkit-slider-runnable-track {
        width: 100%;
        height: 8px;
        cursor: pointer;
        background: #e4e4e4;
      }

      input::-moz-range-track {
        width: 100%;
        height: 8px;
        cursor: pointer;
        background: #e4e4e4;
      }

      input::-ms-track {
        width: 100%;
        height: 8px;
        cursor: pointer;
        background: #e4e4e4;
      }

      input:focus {
        background: none;
        outline: none;
      }

      input::-ms-track {
        width: 100%;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
      }
    }

    .range-labels {
      display: flex;
      padding: 0;
      list-style: none;
      margin: 62px -54px 0;

      li {
        position: relative;
        width: 14.2857%;
        text-align: center;
        color: #222;
        font-size: 14px;
        font-weight: 600;

        span {
          color: #222;
          font-size: 14px;
          font-weight: 600;
        }

        .range-tooltip-wrapper {
          position: absolute;
          top: -337px;
          left: 52%;
          -webkit-transform: translatex(-50%);
          -moz-transform: translatex(-50%);
          -ms-transform: translatex(-50%);
          -o-transform: translatex(-50%);
          transform: translatex(-50%);
          display: none;
        }

        &:first-child .range-tooltip-wrapper {
          left: 55%;
        }

        &:nth-child(2) .range-tooltip-wrapper {
          left: 54%;
        }

        &:nth-child(5) .range-tooltip-wrapper {
          left: 50%;
        }

        &:nth-child(6) .range-tooltip-wrapper  {
          left: 48%;
        }

        &:last-child .range-tooltip-wrapper {
          left: 46%;
        }

        &.active .range-tooltip-wrapper {
          display: block;
        }

        &.active {
          color: #222;
        }

        &:first-child {
          padding-left: 30px;
        }

        &:first-child:after {
          left: 35%;
        }

        &:last-child {
          padding-right: 30px;
        }

        &:last-child:after {
          left: 65%;
        }

        &:after {
          content: "";
          width: 2px;
          height: 8px;
          background-color: #2222223D;
          position: absolute;
          left: 50%;
          transform: translatex(-50%);
          top: -10px;
        }
      }
    }

    .price-page-slider {
      max-width: 1012px;
      margin: 0 auto;
    }

    .range-tooltip-inner {
      position: relative;
      width: 236px;
      background-color: #fff;
      box-shadow: 0 12px 24px #2222221E;
      text-align: left;
    }

    .pricing-plan {
      background-color: #0076C014;
      color: #0076C0;
      font-size: 14px;
      font-weight: 600;
      padding: 8px;
    }

    .subscription-price {
      font-weight: 600;
      font-size: 22px;
      line-height: 29px;
      margin-top: 16px;
    }

    .turnover-range {
      font-size: 16px;
      font-weight: 500;
    }

    .range-tooltip-inner:after {
      content: '';
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-right: 15px solid transparent;
      border-left: 15px solid transparent;
      border-bottom: 15px solid transparent;
      border-top: 15px solid #222222;
      bottom: -30px;
      left: 50%;
      -webkit-transform: translatex(-50%);
      -moz-transform: translatex(-50%);
      -ms-transform: translatex(-50%);
      -o-transform: translatex(-50%);
      transform: translatex(-50%);
    }

    .zento-prices {
      border-bottom: 1px solid #e4e4e4;
      padding: 12px 16px;

      span {
        color: #717171;
        font-size: 14px;
        font-weight: 500;
        margin: 3px 0;
      }

      > p {
        font-size: 18px;
        margin: 10px 0;
      }

      > em {
        font-style: normal;
        font-size: 12px;
      }
    }

    .turnover-rage-price  {
      background-color: #2222220A;
      padding: 8px 16px;

      p {
        font-size: 14px;
        line-height: 1.5;
        font-weight: 500;
        margin: 3px 0;
      }
    }

    .call-us-wrapper {
      padding: 16px;

      span {
        font-weight: 500;
        color: #717171;
        margin-bottom: 16px;
        display: block;
        line-height: 1.5;
      }

      p {
        font-size: 18px;
        color: #0076C0;
        padding-bottom: 32px
      }

      .item-link {
        font-weight: 600;
        font-size: 18px;
        color: #0076C0;
        padding-bottom: 32px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .price-page-info-wraper {
    text-align: center;
    padding-top: 72px;
    color: #222222;
    padding-left: 20px;
    padding-right: 20px;

    p {
      font-size: 18px;
      line-height: 1.5;
      font-weight: 500;
      margin: 0;

      strong {
        font-weight: 600;
      }
    }
  }

  .page-items-button {
    text-align: center;
    margin-top: 48px;
    padding-left: 20px;
    padding-right: 20px;

    .popup-button {
      display: inline-block;
      cursor: pointer;
      padding: 15px 20px;
      border: 0;
      font-weight: 600;
      background-color: #0076c0;
      color: #fff;
      font-size: 18px;

      &:hover {
        background-color: #0169AA;
      }
    }
  }
}

.subscription-services-wrapper {
  max-width: 1290px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 120px;

  .subtitle {
    text-align: center;
    margin-top: 0;
    margin-bottom: 48px;
    font-size: 44px;
    line-height: 1.2;
    display: block;
    font-weight: 600;
    font-style: normal;
    text-transform: none;
    color: #222;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  .subscription-services-items {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    margin-left: -16px;
    margin-right: -16px;

    .subscription-services-item {
      position: relative;
      width: 33.33%;
      float: left;
      padding: 24px 16px;
      text-align: center;

      .subscription-services-img {
        line-height: 0;
        margin-bottom: 24px;
      }

      .subscription-services-title {
        padding: 0 10px;

        h3 {
          font-size: 22px;
          line-height: 29px;
          font-weight: 600;
          color: #222;
          margin: 0;
        }
      }
    }
  }
}

.responsability-chart-wrapper {
  max-width: 1290px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 96px;

  h2 {
    margin-top: 0;
    margin-bottom: 48px;
    font-size: 31px;
    line-height: 1.3;
    font-weight: 400;
    color: #333333;

    strong {
      font-weight: 600;
    }
  }

  .responsability-chart {
    table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      empty-cells: show;
  
      tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        text-align: left;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 500;
        color: #222222;
  
        &.responsability-chart-heading {
          th {
            font-size: 22px;
            line-height: 1.35;
            font-weight: 600;
            border-top: 1px solid #222222;
            color: #2222227A;
          }
  
          td {
            font-size: 22px;
            line-height: 1.35;
            font-weight: 600;
            border-top: 1px solid #222222;
            color: #222222;

          }
        }
  
        th {
          box-sizing: border-box;
          padding: 18px 0;
          border-top: 1px solid #2222221F;
          width: 50%;
          font-weight: 500;
          
          em {
            font-style: normal;
            color: #0076C0;
          }

          .tabel-link {
            span {
              text-decoration: underline;
              color: #0076C0;
            }
          }
        }
  
        td {
          padding: 18px 0;
          border-top: 1px solid #2222221F;
          width: 25%;
          text-align: center;
  
          .responsability-chart-assisted {
            display: flex;
            align-items: center;
            justify-content: center;
  
            span {
              color: #222222A3;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1450px) {
  .price-wrapper {
    padding-top: 96px;
    padding-bottom: 160px;
  }
}

@media (max-width: 1199px) {
  .price-wrapper {
    padding-bottom: 120px;

    .pages-introduction {
      h2 {
        font-size: 44px;
        max-width: 700px;
      }
    }

    .price-page-slider-wrapper {
      .range-labels {
        li {
          &:first-child .range-tooltip-wrapper {
            left: 180px;

            .range-tooltip-inner::after {
              left: 25px;
            }
          }

          &:last-child .range-tooltip-wrapper {
            left: -20px;

            .range-tooltip-inner::after {
              left: initial;
              right: 0;
            }
          }

          &:nth-child(2) .range-tooltip-wrapper {
            left: 56%;
          }

          &:nth-child(5) .range-tooltip-wrapper {
            left: 50%;
          }

          &:nth-child(6) .range-tooltip-wrapper {
            left: 47%;
          }
        }
      }
    }
  }
}

@media (max-width: 995px) {
  .price-wrapper {
    padding-top: 48px;
    padding-bottom: 96px;

    .pages-introduction {
      h2 {
        font-size: 31px;
      }

      p {
        font-size: 18px;
      }
    }

    .price-page-slider-wrapper {
      .range-labels {
        margin: 62px -35px 0;

        li {
          &:first-child .range-tooltip-wrapper {
            left: 163px;
          }

          &:last-child .range-tooltip-wrapper {
            left: -40px;
          }

          &:nth-child(2) .range-tooltip-wrapper {
            left: 58%;
          }

          &:nth-child(3) .range-tooltip-wrapper {
            left: 54%;
          }
        }
      }
    }
  }

  .subscription-services-wrapper {
    margin-top: 96px;

    .subtitle {
      font-size: 31px;
    }

    .subscription-services-items {
      .subscription-services-item {
        .subscription-services-title {
          padding: 0;

          h3 {
            font-size: 18px;
            line-height: 1.3;
          }
        }
      }
    }
  }

  .responsability-chart-wrapper {
    margin-top: 72px;

    h2 {
      font-size: 26px;
    }
  }
}

@media (max-width: 767px) {
  .price-wrapper {
    padding-bottom: 72px;

    .price-page-slider-wrapper {
      .range-labels {
        margin: 62px -25px 0;

        li {
          > span {
            font-size: 0;
          }

          &:first-child .range-tooltip-wrapper {
            left: 152px;
          }

          &:last-child .range-tooltip-wrapper {
            .range-tooltip-inner::after {
              right: 10px;
            }
          }
        }
      }
    }
  }

  .subscription-services-wrapper {
    .subscription-services-items {
      .subscription-services-item {
        width: 50%;
        margin-bottom: 24px;

        &:last-child {
          margin: 0 auto;
        }
      }
    }
  }

  .responsability-chart-wrapper {
    h2 {
      font-size: 22px;
      margin-bottom: 24px;
    }

    .responsability-chart {
      table {
        tr {
          &.responsability-chart-heading {
            th {
              font-size: 18px;
            }

            td {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 639px) {
  .price-wrapper {
    .price-page-slider-wrapper {
      .range-labels {
        margin: 62px -20px 0;

        li {
          > span {
            font-size: 0;
          }

          &:first-child .range-tooltip-wrapper {
            left: 147px;
          }

          &:last-child .range-tooltip-wrapper {
            left: -60px;

            .range-tooltip-inner::after {
              right: 8px;
            }
          }

          &:nth-child(2) .range-tooltip-wrapper {
            left: 100%;

            .range-tooltip-inner::after {
              left: 42%;
            }
          }

          &:nth-child(3) .range-tooltip-wrapper {
            left: 62%;
          }

          &:nth-child(5) .range-tooltip-wrapper {
            left: 45%;
          }

          &:nth-child(6) .range-tooltip-wrapper {
            left: 0;

            .range-tooltip-inner::after {
              left: 60%;
            }
          }
        }
      }
    }

    .price-page-info-wraper {
      p {
        font-size: 16px;
      }

      .page-items-button {
        .popup-button {
          font-size: 16px;
        }
      }
    }
  }

  .subscription-services-wrapper {
    margin-top: 64px;

    .subtitle {
      font-size: 22px;
      margin-bottom: 24px;
    }
  }

  .responsability-chart-wrapper {
    margin-top: 64px;

    .responsability-chart {
      table {
        tr {
          th {
            width: 60%;
          }

          td {
            width: 20%;
          }
        }
      }
    }
  }
}

@media (max-width: 479px) {
  .price-wrapper {
    .pages-introduction {
      text-align: left;
    }

    .price-page-slider-wrapper {
      .range {
        input::-webkit-slider-thumb {
          width: 48px;
          height: 48px;
          margin: -21px 0 0;
        }

        input::-moz-range-thumb {
          width: 48px;
          height: 48px;
          margin: -21px 0 0;
        }

        input::-ms-thumb {
          width: 48px;
          height: 48px;
          margin: -21px 0 0;
        }
      }

      .range-labels {
        margin: 62px -14px 0;

        li {
          &:first-child .range-tooltip-wrapper {
            left: 132px;
          }

          &:nth-child(2) .range-tooltip-wrapper {
            left: 75px;

            .range-tooltip-inner::after {
              left: 80px;
            }
          }

          &:nth-child(3) .range-tooltip-wrapper {
            left: 70px;

            .range-tooltip-inner::after {
              left: 80px;
            }
          }

          &:nth-child(5) .range-tooltip-wrapper {
            left: 0;

            .range-tooltip-inner::after {
              left: initial;
              right: 65px;
            }
          }

          &:nth-child(6) .range-tooltip-wrapper {
            left: -40px;

            .range-tooltip-inner::after {
              left: initial;
              right: 28px;
            }
          }

          &:last-child .range-tooltip-wrapper {
            left: -80px;

            .range-tooltip-inner::after {
              left: initial;
              right: 0;
            }
          }
        }
      }
    }
  }

  .subscription-services-wrapper {
    .subscription-services-items {
      .subscription-services-item {
        width: 100%;
        float: none;
      }
    }
  }
}
